
<ng-particles [id]="id" [options]="particlesOptions" (particlesLoaded)="particlesLoaded($event)" (particlesInit)="particlesInit($event)">





</ng-particles>

<div class="container main-container">
  <h1>Firechat por Xavier Ortega</h1>
  <br>
  <div class="chat-window" *ngIf="_cs.usuario.uid">
    <app-chat></app-chat>
  </div>
  <div class="col-md-12 text-end" *ngIf="_cs.usuario.uid">
    <button type="button" class="btn btn-danger btn-lg" (click)="_cs.logout()">
      <i class="fas fa-door-open"></i>
      Cerrar Sesión
    </button>
  </div>
  <app-login *ngIf="!_cs.usuario.uid"></app-login>
</div>
